import React from 'react';
import styled from 'styled-components';
import { Crumbs, ICrumb } from '../components/Crumbs';
import { ROUTE_PATH } from '../utils/consts';
import { MainWrapper } from '../wrappers/MainWrapper';

interface InstructionsProps {}

export const Instructions: React.FC<InstructionsProps> = () => {
  const crumbs: ICrumb[] = [
    {
      title: 'Головна',
      isLink: true,
      path: ROUTE_PATH.home,
      id: 1,
    },
    {
      title: 'Iнструкція',
      isLink: false,
      active: true,
      id: 2,
    },
  ];
  return (
    <MainWrapper>
      <div className="container">
        <Crumbs data={crumbs} />
        <WrapperTextS className="text-center pt-5">
          <h1>Iнструкція</h1>
          <p className="mt-4">
            Для того щоб переглянути прийом, оберіть навчальну технологію, якої він стосується. Наприклад, клікніть вкладку «Кейс-технологія». У випадному списку оберіть навчальний прийом, приміром «Ситуаційне завдання». Перегляньте картку з описом прийому. Скачайте її або роздрукуйте за допомогою відповідних кнопок. Щоб зберегти навчальний прийом у власній картотеці прийомів, клікніть «Копіювати». Щоб повернутися до переліку прийомів, клікніть на відповідну кнопку наприкінці картки.
          </p>
        </WrapperTextS>
      </div>
    </MainWrapper>
  );
};

const WrapperTextS = styled.div`
  max-width: 900px;
  margin: auto;
`;
